import type { LoadingProps } from './const';
import { cn } from '@utils';
import { IconLoading } from '@wegic/icon';
import { forwardRef } from 'react';
import './index.less';

function Loading(props: LoadingProps, ref: React.Ref<HTMLDivElement>) {
  const { size = 20, color = '#000000', maskColor, style, className = '', block, mask } = props;
  return (
    <div
      ref={ref}
      className={cn('wg-loading', className, {
        'wg-loading--block': block,
        'wg-loading--mask': mask,
      })}
      style={{
        backgroundColor: maskColor,
      }}
    >
      <IconLoading
        className="wg-loading__icon"
        style={{ fontSize: size, color, width: size, height: size, ...style }}
      />
    </div>
  );
}

const LoadingComponent = forwardRef<HTMLDivElement, LoadingProps>(Loading);
LoadingComponent.displayName = 'Loading';

export default LoadingComponent;

export type { LoadingProps };
